module.exports = __webpack_public_path__ + "img/Urheileva-Alkoholisti.1568c16b.png";